<template>
  <div class="dial-table-container">
    <div class="left-table" v-if="dialInfo.original">
      <div v-if="dialInfo.modified.label" class="table-header">{{ dialInfo.original.label }}</div>
      <div class="left-table-container">
        <div class="row" v-for="(row, index) in dialInfo.original.data" :key="`row-${index}`">
          <div v-if="row.label && row.labelName !== 'Dial Title'" class="header">{{ row.label }}</div>
          <div class="data" v-if="row.label">{{ row.value }}<span v-if="row.format === '#.0%'">%</span></div>
        </div>
      </div>
    </div>
    <div
      class="right-table"
      v-if="
        dialInfo.modified &&
        dialInfo.modified.data &&
        dialInfo.modified.data.length > 0 &&
        dialInfo.properties.modified !== 'N'
      "
    >
      <div v-if="dialInfo.modified.label" class="table-header">{{ dialInfo.modified.label }}</div>
      <div class="right-table-container">
        <div class="row" v-for="(row, index) in dialInfo.modified.data" :key="`row-${index}`">
          <div v-if="row.label && row.value" class="header">{{ row.label }}</div>
          <div class="data">{{ row.value }}<span v-if="row.format === '#.0%'">%</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SM',
  components: {},
  props: {
    dialInfo: {
      type: Object,
    },
  },
  data() {
    return {};
  },
  created() {},
  computed: {},
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
